function ContractIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 32 32"
      fill="#A8ADB2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M25.74 19.28h-3.36V8.36a2.52 2.52 0 00-2.52-2.52H8.94a2.52 2.52 0 00-2.52 2.52v12.6a4.2 4.2 0 004.2 4.2h11.76a4.2 4.2 0 004.2-4.2v-.84a.84.84 0 00-.84-.84zM8.1 20.96V8.36a.84.84 0 01.84-.84h10.92a.84.84 0 01.84.84v10.92h-6.72a.84.84 0 00-.84.84v.84a2.52 2.52 0 01-5.04 0zm14.28 2.52h-8.421a4.155 4.155 0 00.861-2.52H24.9a2.52 2.52 0 01-2.52 2.52z" />
      <path d="M10.62 10.88h7.56a.84.84 0 100-1.68h-7.56a.84.84 0 100 1.68zM10.62 14.24h7.56a.84.84 0 100-1.68h-7.56a.84.84 0 100 1.68zM18.18 17.6a.84.84 0 100-1.68h-7.56a.84.84 0 100 1.68h7.56z" />
    </svg>
  )
}

export default ContractIcon
